<template>
	<div id="iContent">
		<div>
			<div v-for="item in tableData">
				<div><img :src="item.images"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import qs from 'qs'
	export default{
		data(){
			return{
				tableData: [],
				loading: false
			}
		},
		mounted(){
			this.handleSearch()
		},
		methods:{
			handleSearch(){
		        this.search();
		    },
			// 查询列表
	  		search:function(){
	  			let that = this;
	  			this.HOST = 'http://www.qhmuseum.cn/qhm-webapi';
	  			let url = this.HOST + '/organization/getList';
	  			that.loading = true;
	  			this.$axios.post(url).then(function(result){
	  				let cData = result.data;
	  				if(cData && cData.data){
	  					that.tableData = cData.data;
	  					console.log(that.tableData);
	  				}
	  			}).catch(function(error){
	  				console.log(err);
	  			})
	  		}
		}
	}
</script>

<style scoped>
#iContent{
	width: 100%;
}
#iContent>div:nth-child(1){
	width: 94%;
	margin:10px 3%;
}
#iContent>div:nth-child(1)>div{
	width: 100%;
}
#iContent>div:nth-child(1)>div>div:nth-child(1){
	padding-top: 30px;
	text-align: left;
	line-height: 40px;
	font-size: 18px;
}
</style>


// WEBPACK FOOTER //
// src/pages/about/organization.vue